import React from 'react'

import { TherapistFilterMenuTriggerUI } from '@/src/domains/therapist-filters/components/TherapistFilterMenuTrigger'

import { getTranslate } from '../../utilities/i18n'
import useOutsideClick from '../../utilities/useClickOutside'

type Props = { menuClassName?: string; closeOnOutsideClick?: boolean; children: React.ReactNode }

const ExtendedFilter: React.FC<Props> = ({ children, menuClassName, closeOnOutsideClick = false }) => {
  const [isFilterOpen, setIsFilterOpen] = React.useState(false)
  const { t } = getTranslate()

  const handleClickOutside = () => closeOnOutsideClick && setIsFilterOpen(false)
  const ref = useOutsideClick(handleClickOutside)

  return (
    <div className="relative" ref={ref}>
      <TherapistFilterMenuTriggerUI
        icon="filter"
        onClick={() => setIsFilterOpen((value) => !value)}
        data-state={isFilterOpen ? 'open' : 'closed'}
      >
        {t('components.filter.extendedFilter.title')}
      </TherapistFilterMenuTriggerUI>
      {isFilterOpen && (
        <div
          className={`z-10 mt-2 w-full rounded-xl bg-white p-2 shadow-hedepy tablet:w-max tablet:min-w-[270px] ${menuClassName || ''}`}
        >
          {children}
        </div>
      )}
    </div>
  )
}

export default ExtendedFilter
